import React from 'react';
import './App.css';
import { NavLink, Switch, Route, Link } from 'react-router-dom';

// --- CARD ELEMENT ---
import CustomCard from './components/CustomCard.jsx'
import TwoColumn from './components/TwoColumn.jsx'

// --- ENTRY PAGES ---
import Entry from './pages/cod_rs.jsx';
import Entry2 from './pages/gt_simpplr.jsx';
import Entry3 from './pages/as_notifdash.jsx';
import Entry4 from './pages/dm_gj.jsx';

// --- IMAGES ---
import img from './images/wallpaperGradient.png';
import codCardImg from './images/codOverview.png';
import simpplrCardImg from './images/KnowledgeHiFi1.png';
import arenaCardImg from './images/notifLaptop.png';
import dmCardImg from './images/dmOverview.png';
import profPic from './images/profPic.png';


const App = () => (
  <div className='app'>
    <Navigation />
    <Main />
   </div>
);

// HEADER NAVIGATION
const Navigation = () => (
  <nav>
    <ul>
      <li><NavLink exact activeClassName="current" to='/'>Home</NavLink></li>
      <li><NavLink exact activeClassName="current" to='/extras'>Extras</NavLink></li>
      <li><NavLink exact activeClassName="current" to='/about'>About</NavLink></li>
    </ul>
  </nav>
);


// HOME PAGE CONTENTS
const Home = () => (

  <div className='home'>

  {/* FUNCTIONS: SETTING BG, SCROLLTO*/}
    <script>
        window.onload = function() {
            document.body.style.backgroundImage = `url(${img})`
        };
    </script>
    <script>
        window.onload = function2() {
            document.body.style.backgroundRepeat = "no-repeat"
        };
    </script>
    <script>
        window.onload = function3() {
           window.scrollTo(0, 0)
        };
    </script>
    

    {/* ------------------------------ PAGE HEADER ------------------------------ */}
    <h1>Hi! I'm Annie!</h1>
    <h2>UX Designer, UI Artist, Illustrator</h2>
    <hr class="divider3"></hr>
    
    {/* ------------------------------ CARD: SIMPPLR ------------------------------ */}
    <Link to={'/gt_simpplr'} style={{ textDecoration: 'none' }}>
    <CustomCard >
        <div className='card-text'>
              
              <h1 className='card-header'>Simpplr as Industry Sponsor @ Gatech</h1> 
              <h1 className='card-title'> Designing a Dashboard's Information Architecture</h1>
              <p className = 'card-description'>Deep and varied research methods to determine user needs in a dashboard, and full iterations of designs based on researched insights.</p>

              <hr class="divider3"></hr>
              <p className = 'card-description'> 
                <mark class="UXDTag">UX Design</mark>
                <mark class="tagMargin">_</mark>
                <mark class="UXRTag">UX Research</mark>
              </p>
        </div> 

        <div className='card-img'>
              <img src={simpplrCardImg} alt="" className='card-image' /> 
        </div>

      </CustomCard>
    </Link>

  {/* ------------------------------ CARD: COD ------------------------------ */}
  <Link to={'/cod_rs'} style={{ textDecoration: 'none' }}>
    <CustomCard >

        <div className='card-text'>
              <h1 className='card-header'>Call of Duty:  Modern Warfare 3</h1> 
              <h1 className='card-title'> Creating UI Art for Call of Duty</h1>
              <p className = 'card-description'>Learning the process of creating icons, victory animations, and other UI elements for a triple-A shooter game.</p>
              <hr class="divider3"></hr>
              <p className = 'card-description'> 
                <mark class="UIArtTag">UI Art</mark>
                <mark class="tagMargin">_</mark>
                <mark class="MoGraphTag">Motion Graphics</mark>
              </p>
        </div> 

        <div className='card-img'>
              <img src={codCardImg} alt="" className='card-image' /> 
        </div>

    </CustomCard>
  </Link>

  {/* ------------------------------ CARD: ARENA ------------------------------ */}
  <Link to={'/wip'} style={{ textDecoration: 'none' }}>
  <CustomCard >
      <div className='card-text'>
            
            <h1 className='card-header'>Arena Solutions</h1> 
            <h1 className='card-title'>Research & Design for Complex Notification Display</h1>
            <p className = 'card-description'>Iteratively conducting interviews and a/b testing in order to inform our designed wireframes and prototypes of a notification display.</p>

            <hr class="divider3"></hr>
            <p className = 'card-description'> 
              <mark class="UXDTag">UX Design</mark>
              <mark class="tagMargin">_</mark>
              <mark class="UXRTag">UX Research</mark>
            </p>
      </div> 

      <div className='card-img'>
            <img src={arenaCardImg} alt="" className='card-image' /> 
      </div>

    </CustomCard>
  </Link>

  {/* ------------------------------ CARD: DRACOMATON ------------------------------ */}
  <Link to={'/wip'} style={{ textDecoration: 'none' }}>
  <CustomCard >
      <div className='card-text'>
            
            <h1 className='card-header'>Senior Capstone @ UCSC</h1> 
            <h1 className='card-title'>Designing for Players and for Developers</h1>
            <p className = 'card-description'>Creating a game’s design system from scratch, and exploring what it means to create an environment for others to work on games.</p>

            <hr class="divider3"></hr>
            <p className = 'card-description'> 
              <mark class="UXDTag">UX Design</mark>
              <mark class="tagMargin">_</mark>
              <mark class="UIArtTag">UI Art</mark>
              <mark class="tagMargin">_</mark>
              <mark class="ProjMgtTag">Project Management</mark>
            </p>
      </div> 

      <div className='card-img'>
            <img src={dmCardImg} alt="" className='card-image' /> 
      </div>

    </CustomCard>
  </Link>


  <hr class="divider3"></hr>
  <hr class="divider3"></hr>
  </div>

  
);

// EXTRAS PAGE CONTENTS
const extras = () => (
  <div className='extras'>
    
    <p><strong>Still under construction!</strong></p>
    <hr class="spacerLarge"></hr>
  </div>
);

// ABOUT PAGE CONTENTS
const About = () => (
  <div className='about' >
    <script>
        window.onload = function() {
            document.body.style.backgroundImage = `url(${img})`
        };
    </script>
    <script>
        window.onload = function2() {
            document.body.style.backgroundRepeat = "no-repeat"
        };
    </script>


    <h1>About Me</h1>
    <TwoColumn>
                    <div className='twoCol-text'>
                            <p> </p>
                            <e-h2>Hello! I'm Annie, a UXD looking for work. I'm a UI/UX designer and illustrator seeking opportunities in the Games and Tech industries.</e-h2>
                           
                        
                    </div> 
            
                    <div className='twoCol-img'>
                            <img src={profPic} alt="" className='twoCol-image' /> 
                    </div>
            
    </TwoColumn>
    
    <hr class="spacerLarge"></hr>
  </div>
);

const WIP = () => (
  <div className='wip' >
    <script>
      window.onload = function3() {
        window.scrollTo(0, 0)
      };
    </script>
    <p><strong>Still under construction!</strong></p>
    <hr class="spacerLarge"></hr>
  </div>
);


// ENTRY PAGE SWITCHING
const cod_rs = () => (
  <Entry />
);
const gt_simpplr = () => (
  <Entry2 />
);
const as_notifdash = () => (
  <Entry3 />
);
const dm_gj = () => (
  <Entry4 />
);


// LINK SWITCHING MAIN
const Main = () => (
  <Switch>
    <Route exact path='/' component={Home}></Route>
    <Route exact path='/extras' component={extras}></Route>
    <Route exact path='/about' component={About}></Route>
    <Route exact path='/wip' component={WIP}></Route>
    
    
    <Route exact path='/cod_rs' component={cod_rs}></Route>
    <Route exact path='/gt_simpplr' component={gt_simpplr}></Route>
    <Route exact path='/as_notifdash' component={as_notifdash}></Route>
    <Route exact path='/dm_gj' component={dm_gj}></Route>

  </Switch>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js